<div class="comment-customer-feedback">
  @if (!feedbackSent) {
    <span class="comment-customer-feedback-question">Is this answer helpful?</span>
    <div class="comment-customer-feedback-options">
      <button semerisButton variant="text" (click)="onFeedbackClick('Yes')" color="accent"><mat-icon>thumb_up</mat-icon>Yes</button>
      <button semerisButton variant="text" (click)="onFeedbackClick('No')" color="warn"><mat-icon>thumb_down</mat-icon>No</button>
      <button semerisButton variant="text" (click)="onFeedbackClick('Not sure')">Not sure</button>
    </div>
  } @else {
    <span class="comment-customer-feedback-thanks">Thanks for your feedback!</span>
  }
</div>

